import { useState, useEffect, useRef } from "react";
import SelectItem from "../SelectItem";
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, Typography, IconButton, Divider, Chip, LinearProgress } from '@mui/material';
import { ExpandMore, Delete } from '@mui/icons-material';
import ArticuloService from '../../services/articulos';
import { OPERATION } from '../../helpers/enums';
import Articles from "../Table/Mobile/Articles";
import { ccyFormat } from "../../helpers/helper";

const mapItems = articles => articles?.map(article => ({
  id: article._id,
  name: article.article.name,
  image: article.article.images?.length > 0 ? article.article.images[0] : [],
  description: `${article.sku}   --   $${ccyFormat(article.prices.sale_price)}`,
  available: article.quantity > 0,
  sku: article.sku,
  article: article
}))

const SelectArticles = ({ articles, onClose, artsSelected = [], onSave, readOnly = false }) => {
  const [loadingArticulos, setLoadingArticulos] = useState(false);
  const [items, setItems] = useState(mapItems(articles));
  const [searchTerm, setSearchTerm] = useState("");
  const [articlesSelected, setArticlesSelected] = useState(artsSelected);

  const handleSearch = ({ searchQuery }) => {
    setSearchTerm(searchQuery);
  };

  const filteredList = items?.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) || item?.sku.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectItem = itemToAdd => {
    setLoadingArticulos(true)
    // var itemToAdd = articles.find(article => article._id === id);
    if (!articlesSelected.includes(itemToAdd.article))
      setArticlesSelected([...articlesSelected, itemToAdd.article])
    setLoadingArticulos(false)
  }

  return (<Box>
    {loadingArticulos && <LinearProgress color='secondary' />}
    <Box display='flex' flexDirection='column' width='100%'>
      {articlesSelected?.map(article => (<Box display='flex' >
        <Accordion sx={{width: '100%'}}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            id="panel1-header"
            // sx={{ padding: 0, minHeight: "unset", "& .MuiAccordionSummary-content": { margin: 0 }, alignSelf: 'center' }}
            sx={{
              minHeight: "35px", // Altura fija para evitar cambios al expandirse
              "&.Mui-expanded": {
                minHeight: "35px", // Altura fija también cuando está expandido
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
              },
            }}
          >
            <Typography variant="caption" component="span">{article.article.name}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Articles
              arts={articlesSelected.filter(a => a._id === article._id)}
              readOnly={readOnly}
            />
          </AccordionDetails>
        </Accordion>
        <IconButton edge="end" aria-label="delete" onClick={() => setArticlesSelected([...articlesSelected.filter(a => a._id !== article._id)])}>
          <Delete />
        </IconButton>
      </Box>))}
    </Box>
    <Box >
      <Divider sx={{ marginBottom: 1, marginTop: 3 }}>
        <Chip label="Articulos disponibles" size="small" />
      </Divider>
      <SelectItem
        items={filteredList}
        onSearch={handleSearch}
        onSelect={handleSelectItem}
      />
    </Box>
    <Box sx={{
      position: 'sticky',
      bottom: 0,
      backgroundColor: 'white',
      padding: '10px',
      borderTop: '1px solid #ccc',
      mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center"
    }}>
      <Button
        type="submit"
        variant="outlined"
        onClick={onClose}
      //disabled={saving}
      >Cancelar</Button>
      <Button
        type="submit"
        variant="outlined"
        disabled={articlesSelected?.length <= 0}
        onClick={() => onSave && onSave(articlesSelected)}
      >Guardar</Button>
    </Box>
  </Box>)
}

export default SelectArticles;